export const EMAIL_TEMPLATE_DETAILS = "EMAIL_TEMPLATE_DETAILS"
export const EMAIL_TEMPLATE_DETAILS_SUCCESS = "EMAIL_TEMPLATE_DETAILS_SUCCESS"
export const EMAIL_TEMPLATE_DETAILS_FAILED = "EMAIL_TEMPLATE_DETAILS_FAILED"

export const ADD_EMAIL_TEMPLATE = "ADD_EMAIL_TEMPLATE"
export const ADD_EMAIL_TEMPLATE_SUCCESS = "ADD_EMAIL_TEMPLATE_SUCCESS"
export const ADD_EMAIL_TEMPLATE_FAILED = "ADD_EMAIL_TEMPLATE_FAILED"

export const EDIT_EMAIL_TEMPLATE = "EDIT_TEMPLATE"
export const EDIT_EMAIL_TEMPLATE_SUCCESS = "EDIT_EMAIL_TEMPLATE_SUCCESS"
export const EDIT_EMAIL_TEMPLATE_FAILED = "EDIT_EMAIL_TEMPLATE_FAILED"

export const GET_DEFAULT_EMAIL_TEMPLATE_DATA = "GET_DEFAULT_EMAIL_TEMPLATE_DATA"
export const GET_DEFAULT_EMAIL_TEMPLATE_DATA_SUCCESS = "GET_DEFAULT_EMAIL_TEMPLATE_DATA_SUCCESS"
export const GET_DEFAULT_EMAIL_TEMPLATE_DATA_FAIL = "GET_DEFAULT_EMAIL_TEMPLATE_DATA_FAIL"